import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";

import { environment as ENV } from "environments/environment";
import { PageClienteDTO } from "../../interfaces/page-cliente.interface";
import { ClienteDTO } from "../../interfaces/cliente.interface";
import { NuevoClienteDTO } from "../../models/cliente.model";
import { PersonaDTO } from "../../interfaces/persona.interface";
import { NuevoRepresentanteDTO } from "../../models/representante.model";
import { SucursalPersonaDTO } from "../../interfaces/sucursal-persona.interface";
import { Sucursal } from "../../interfaces/sucursal.interface";
import { FiltrosService } from "../util/filtros.service";
const API = "clientes";

@Injectable({
    providedIn: "root",
})
export class ClienteService {
    clienteRefresh$: BehaviorSubject<boolean>;
    clientesChanged$: Subject<PageClienteDTO>;
    clienteStatusChanged$: Subject<ClienteDTO>;

    private paginaActual: number;
    private cantidaResultadosPorPagina: number;
    private totalDeResultados: number;
    private cantidadPaginas: number;
    private orden: string;
    private campoOrden: string;
    
    constructor(private http: HttpClient, private _filtros: FiltrosService) {
        this.clientesChanged$ = new Subject();
        this.clienteStatusChanged$ = new Subject();
        this.clienteRefresh$ = new BehaviorSubject(false);
        this.resetPaginador();
    }

    fetchDetalleCliente(idCliente:number): Observable<ClienteDTO> {
        //console.log(`${ENV.apiUrl}${API}/${idCliente}`);
        return this.http.get<ClienteDTO>(`${ENV.apiUrl}${API}/${idCliente}`);
    }

    fetchClientes(
        pagina?: number,
        orden?: string
    ): Observable<PageClienteDTO> {

        const filtrosCliente = this._filtros.getFiltro("filtrosClientes");
        let parametros:string='';
        parametros+=(filtrosCliente.cliente[0].valor != '')?'&nombre='+filtrosCliente.cliente[0].descripcion:'';
        parametros+=(filtrosCliente.estado[0].valor>0)?'&situacion='+filtrosCliente.estado[0].valor:'';


        return this.http.get<PageClienteDTO>(
            `${ENV.apiUrl}${API}?page=${
                this.paginaActual
            }&size=${this.cantidaResultadosPorPagina}${parametros}&sort=${this.campoOrden},${this.orden}`
        );
        //return this.http.get<PageClienteDTO>(
        //    `${ENV.apiUrl}${API}?page=${pagina}&sort=nrRut,${orden}`
        //);
    }

    disableCliente(idCliente:number):Observable<any>{
        return this.http.patch(`${ENV.apiUrl}${API}/${idCliente}/desactivar`, null);
    }

    enableCliente(idCliente:number):Observable<any>{
        return this.http.patch(`${ENV.apiUrl}${API}/${idCliente}/activar`, null);
    }



    save(nuevo:NuevoClienteDTO):Observable<any>{
        return this.http.put(
            `${ENV.apiUrl}${API}`,nuevo);
    }


    fetchRepresentantes(idCliente: number): Observable<PersonaDTO> {
        return this.http.get<PersonaDTO>(
            `${ENV.apiUrl}${API}/${idCliente}/representantes`
        );
    }

    saveRepresentante(idCliente: number, nuevo: NuevoRepresentanteDTO): Observable<any> {
        return this.http.post(
            `${ENV.apiUrl}${API}/${idCliente}/representante`,
            nuevo
        );
    }

    delete(idCliente: number, nrRutRepresentante: number) {
        return this.http.delete<any>(
            `${ENV.apiUrl}${API}/${idCliente}/representante/${nrRutRepresentante}`
        );
    }

    fetchSucursales(idCliente: number): Observable<Sucursal[]> {
        return this.http.get<Sucursal[]>(
            `${ENV.apiUrl}${API}/${idCliente}/sucursales`
        );
    }


    setCantidadPaginas(cantidadPaginas: number): void {
        this.cantidadPaginas = cantidadPaginas;
    }

    getCantidadPaginas(): number {
        return this.cantidadPaginas;
    }

    getTotalDeResultados(): number {
        return this.totalDeResultados;
    }

    setTotalDeResultados(totalDeResultados: number): void {
        this.totalDeResultados = totalDeResultados;
    }

    setOrden(orden: string): void {
        this.orden = orden;
    }

    setCampoOrden(campoOrden: string) {
        this.campoOrden = campoOrden;
    }

    getOrden(): string {
        return this.orden;
    }

    setPaginaActual(pagina: number): void {
        this.paginaActual = pagina;
    }

    getPaginaActual(): number {
        return this.paginaActual;
    }

    setCantidaResultadosPorPagina(cantidadResultados: number): void {
        this.cantidaResultadosPorPagina = cantidadResultados;
    }

    getCantidaResultadosPorPagina(): number {
        return this.cantidaResultadosPorPagina;
    }

    resetPaginador() {
        this.paginaActual = 0;
        this.cantidaResultadosPorPagina = 10;
        this.totalDeResultados = 0;
        this.cantidadPaginas = 0;
        this.campoOrden="nrRut"
        this.orden = "asc";
    }

}
